import { Box, Container, Heading, Image, Text } from '@chakra-ui/react';
import React from 'react';

const Arrow = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="23" height="82" viewBox="0 0 23 82" fill="none">
		<path
			d="M10.4393 81.0607C11.0251 81.6464 11.9749 81.6464 12.5607 81.0607L22.1066 71.5147C22.6924 70.9289 22.6924 69.9792 22.1066 69.3934C21.5208 68.8076 20.5711 68.8076 19.9853 69.3934L11.5 77.8787L3.01472 69.3934C2.42894 68.8076 1.47919 68.8076 0.893401 69.3934C0.307615 69.9792 0.307615 70.9289 0.893401 71.5147L10.4393 81.0607ZM10 6.55671e-08L10 2.85714L13 2.85714L13 -6.55671e-08L10 6.55671e-08ZM10 8.57143L10 14.2857L13 14.2857L13 8.57143L10 8.57143ZM10 20L10 25.7143L13 25.7143L13 20L10 20ZM10 31.4286L10 37.1429L13 37.1429L13 31.4286L10 31.4286ZM10 42.8571L10 48.5714L13 48.5714L13 42.8571L10 42.8571ZM10 54.2857L10 60L13 60L13 54.2857L10 54.2857ZM10 65.7143L10 71.4286L13 71.4286L13 65.7143L10 65.7143ZM10 77.1429L10 80L13 80L13 77.1429L10 77.1429Z"
			fill="#686868"
		/>
	</svg>
);

const GatewayToDreamCareer = ({ data }: any) => {
	return (
		<Container maxW={'container.xl'}>
			<Heading textAlign={'center'} as="h2" color="#2B2828">
				{data?.heading}
			</Heading>
			<Box mt="56px" display="flex" flexWrap={'wrap'} flexDir={{ base: 'column', lg: 'row' }} justifyContent={'space-between'} gap="32px">
				{data?.steps.map((step: any, index: number) => {
					return (
						<React.Fragment key={index}>
							<Box justifySelf={'center'} alignSelf={'center'}>
								<Image maxH='80px' mx="auto" src={step.image} alt="image" />
								<Heading mt="16px" textAlign={'center'} as="h3">
									{step.text}
								</Heading>
								{step.description && (
									<Text mt="16px" maxW='271px' textAlign={'center'} textStyle='body1-md'>
										{step.description}
									</Text>
								)}
							</Box>
							{index === data.steps.length - 1 ? null : (
								<Box
									display={'flex'}
									justifySelf={'center'}
									alignSelf={'center'}
									justifyContent={'center'}
									alignItems={'center'}
									w={'80px'}
									h={'80px'}
									transform={{ base: 'none', lg: 'rotate(-90deg)' }}
								>
									<Arrow />
								</Box>
							)}
						</React.Fragment>
					);
				})}
			</Box>
		</Container>
	);
};

export default GatewayToDreamCareer;
